import React from 'react';

const AccessExpiredPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-primary-bg flex items-center justify-center">
      <div className="text-center">
        <p className="text-white text-xl">No access, contact Insyra tech for access</p>
      </div>
    </div>
  );
};

export default AccessExpiredPage;
